// Google Analytics helper functions
export const GA_MEASUREMENT_ID = 'G-FVJGFKWK4J';

// Log a pageview to Google Analytics
export const pageview = (url) => {
  if (window.gtag) {
    window.gtag('config', GA_MEASUREMENT_ID, {
      page_path: url,
    });
  }
};
